import { useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';

export function useSupabaseSubscription(
  table: string,
  onUpdate: () => void
) {
  useEffect(() => {
    const subscription = supabase
      .channel('any')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table,
        },
        () => {
          onUpdate();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [table, onUpdate]);
}